// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const WidgetQuickLinks: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#231f20",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 16 18" width={width} height={height}>
            <path
                fill="currentColor"
                d="M13.642 2.621a2.706 2.706 0 0 0-3.78 0L2.976 9.39a4.17 4.17 0 0 0 0 5.972 4.35 4.35 0 0 0 6.076 0l5.451-5.358a.583.583 0 0 1 .81 0 .56.56 0 0 1 0 .796l-5.45 5.358c-2.127 2.09-5.574 2.09-7.697 0a5.285 5.285 0 0 1 0-7.564l6.886-6.768a3.866 3.866 0 0 1 5.401 0 3.71 3.71 0 0 1 0 5.308l-6.592 6.48a2.43 2.43 0 0 1-3.572-.195 2.33 2.33 0 0 1 .176-3.14l5.448-5.351a.583.583 0 0 1 .81 0 .56.56 0 0 1 0 .796l-5.443 5.35a1.215 1.215 0 0 0-.093 1.64c.466.57 1.334.62 1.86.102l6.596-6.48a2.596 2.596 0 0 0 0-3.715"
            />
        </svg>
    );
};

export default React.memo(WidgetQuickLinks);
